import React, { FC, useEffect } from 'react'
import { BannerContext } from 'core/providers/BannerProvider'

const bannerContainerRef = React.createRef<HTMLDivElement>()

const BannerContainer: FC = (props) => {
  const { setBannerContainer } = React.useContext(BannerContext)

  useEffect(() => {
    // We must set the bannerContainer element ref in the state when the component is mounted
    // so that it is correctly updated and reflected in the BannerContent consumers
    setBannerContainer(bannerContainerRef.current)
  }, [])

  return <div ref={bannerContainerRef} />
}

export default BannerContainer
